import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconSizes, IconUsageTypes } from '@sondermindorg/iris-design-system-angular';
import { IrisIconModule } from '@sondermind/iris/icon';

@Component({
  selector: 'pill',
  standalone: true,
  imports: [CommonModule, IrisIconModule],
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
})
export class PillComponent {
  @Input() icon: string = 'verified_user';
  @Input() text: string = '';
  @HostBinding('attr.data-test') dataTestValue = 'pill';
  iconDecorativeUsage = IconUsageTypes.DECORATIVE;
  iconSmallSize = IconSizes.SM;
}
